module.exports = __webpack_public_path__ + "static/media/white-marble.bb817710.jpg";